'use client'

import { subscribeBlogAPI } from '@/api-config/post';
import Link from 'next/link';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

const NotifyMe = () => {
    const [loader, setLoader] = useState(false);
    const [email, setEmail] = useState(''); // Initialize with an empty string
    const dispatch = useDispatch();

    const handleSuccess = () => {
        setLoader(false);
        setEmail(''); // Reset email to an empty string
    };

    const handleSubmit = () => {
        setLoader(true);
        dispatch(subscribeBlogAPI({ email }, setLoader, handleSuccess));
    };

    return (
        <div className="flex flex-col items-center justify-center w-full text-center px-6 pt-5 pb-[30px] bg-[#EB532E1F]">
            <h2 className="font-bold text-3xl w-full mb-4 text-left">
                Stay up to date
            </h2>
            <p className="text-base text-left mb-7 w-full ">
                Subscribe and get fresh content delivered right to your inbox
            </p>
            <div className="w-full newsletter-form">
                <div>
                    <div className="flex flex-wrap items-center justify-center gap-4">
                        <div className="flex-grow max-w-md">
                            <label htmlFor="email" className="sr-only">
                                Email Address
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="data[email]"
                                placeholder="Email Address *"
                                required
                                className="w-full px-4 py-3 border rounded-lg text-gray-700"
                                value={email}
                                onChange={e => setEmail(e?.target?.value)}
                            />
                        </div>
                        <button
                            onClick={handleSubmit}
                            disabled={loader}
                            className="px-6 py-3 bg-orange-500 text-white rounded-lg text-lg font-semibold hover:bg-orange-600"
                        >
                            {loader ? "Please wait ..." : "Notify Me"}
                        </button>
                    </div>
                </div>
            </div>
            <div className="hidden md:block text-sm w-full text-center mt-6">
                We care about protecting your data. Read our{' '}
                <Link
                    href="https://hyqoo.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 underline"
                >
                    Privacy Policy
                </Link>
                .
            </div>
        </div>
    );
};

export default NotifyMe;
